<template>
  <div class="grade">
    <label>服务评分</label>
    <ul class="star-wrapper">
      <li
        v-for="(item, index) in scoreClassArr"
        :key="index"
        :class="classObj(index)"
        @click="clickStar(index)"
      >
        <p>
          <i></i>
        </p>
      </li>
    </ul>
    <p>{{ getStarText }}</p>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
  props: {
    score: {
      // 评分
      type: [Number, String],
      default: 5
    }
  },
  data() {
    const scoreClassArr = new Array(5)
    return {
      scoreClassArr
    }
  },
  computed: {
    getStarText() {
      const starTextList = ['不满意', '一般', '不错', '满意', '超赞']
      return starTextList[this.selectedGrade * 1 - 1]
    },
    selectedGrade() {
      return this.score * 1
    }
  },
  methods: {
    clickStar(index) {
      if (this.isMaA) {
        if (this.selectedGrade == index + 1) return
        this.$emit('onChangeGrade', index + 1)
      }
    },
    classObj(index) {
      const selectedGrade = this.selectedGrade
      return {
        [`t-${selectedGrade}`]: true,
        selected: index < selectedGrade
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.grade {
  display: flex;
  align-items: center;
  padding-top: rem(24px);
  label {
    flex: none;
    font-size: rem(28px);
    color: #333;
    line-height: rem(36px);
  }
  > p {
    font-size: rem(28px);
    color: #ff397e;
    line-height: rem(36px);
  }
}
.star-wrapper {
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-left: rem(18px);
  padding-right: rem(22px);
  ul {
    display: flex;
    // flex: 1;
    align-items: center;
  }

  li {
    > p {
      i {
        display: block;
        width: rem(70px);
        height: rem(74px);
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('~@/assets/images/evaluate/icon-grade_n@3x.png');
        background-size: rem(46px) auto;
      }
    }
    &.selected {
      &.t-1 i {
        background-image: url('~@/assets/images/evaluate/icon-g_1@3x.png');
      }
      &.t-2 i {
        background-image: url('~@/assets/images/evaluate/icon-g_2@3x.png');
      }
      &.t-3 i {
        background-image: url('~@/assets/images/evaluate/icon-g_3@3x.png');
      }
      &.t-4 i {
        background-image: url('~@/assets/images/evaluate/icon-g_4@3x.png');
      }
      &.t-5 i {
        background-image: url('~@/assets/images/evaluate/icon-g_5@3x.png');
      }
    }
  }
}
</style>
